var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 16.667H8.33335C6.03544 16.667 4.16669 18.5357 4.16669 20.8337V41.667C4.16669 43.9649 6.03544 45.8337 8.33335 45.8337H29.1667C31.4646 45.8337 33.3334 43.9649 33.3334 41.667V20.8337C33.3334 18.5357 31.4646 16.667 29.1667 16.667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 4.16699H20.8334C19.7283 4.16699 18.6685 4.60598 17.8871 5.38738C17.1057 6.16878 16.6667 7.22859 16.6667 8.33366V12.5003H33.3334C34.4384 12.5003 35.4982 12.9393 36.2796 13.7207C37.061 14.5021 37.5 15.5619 37.5 16.667V33.3337H41.6667C42.7718 33.3337 43.8316 32.8947 44.613 32.1133C45.3944 31.3319 45.8334 30.2721 45.8334 29.167V8.33366C45.8334 7.22859 45.3944 6.16878 44.613 5.38738C43.8316 4.60598 42.7718 4.16699 41.6667 4.16699Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.44b1f1f52877c776ad8afca3924595e2.svg";
export { ForwardRef as ReactComponent };